var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 43 43",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    style: {
      backgroundColor: "transparent"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect",
    width: 41.6,
    height: 41.6,
    rx: 5,
    ry: 5,
    transform: "translate(.7 0.7)",
    fill: "#01c5fc",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "elements",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elements-wrapper",
    width: 43,
    height: 43
  }, /*#__PURE__*/React.createElement("path", {
    id: "tail",
    d: "M19.04276,14.90639C20.8,11.6,23.1,10.116705,27.1,10.116705C31.1,10.116705,35.333787,13.614902,35.333787,18.252049",
    transform: "translate(-3.5 0)",
    fill: "none",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2.7,
    strokeDasharray: "22.74 22.74",
    style: {
      mixBlendMode: "normal",
      paintOrder: "fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "inf",
    d: "M31.099206,16.585446C37.213555,16.585447,39.237586,21.056932,39.237586,24.723826C39.237586,28.39072,37.213555,32.862206,31.099206,32.862206C24.984857,32.862206,17.531481,16.585446,12.00834,16.585446C6.485199,16.585446,3.884325,21.056932,3.86996,24.723826C3.855595,28.39072,6.485199,32.862206,12.00834,32.862206C17.531481,32.862206,24.984857,16.585445,31.099206,16.585446Z",
    transform: "matrix(0.919411 0 0 0.797979 1.732665 4.994733)",
    fill: "none",
    stroke: "rgb(255,255,255)",
    strokeWidth: 3,
    strokeDasharray: "83.09 20",
    style: {
      mixBlendMode: "normal",
      paintOrder: "fill"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHsLogo);
export default __webpack_public_path__ + "static/media/HSLogo.6e01d6c5899082cf63feda1f15247db7.svg";
export { ForwardRef as ReactComponent };